import { RuntimeGS } from "../app/RuntimeGS";
import { StateGS } from "./StateGS";
import { WrapperGS } from "../WrapperGS";

export interface PageConstructorGS<TPage extends WrapperGS = WrapperGS> {
    new(existingElement?: HTMLElement): TPage;
}

/** Page-bearing state. The state creates and owns its typed page. */
export abstract class StatePagedGS<TPage extends WrapperGS> extends StateGS {
    public readonly page: TPage;
    public readonly layoutName: string;

    protected constructor(
        pageConstructor: PageConstructorGS<TPage>,
        title: string,
        inHistory = true,
        layoutName = "main"
    ) {
        super(title, inHistory);
        const existingElement = RuntimeGS.current?.pendingPageElement;
        this.page = this.app
            ? this.app.newInst(pageConstructor, existingElement)
            : new pageConstructor(existingElement);
        this.layoutName = layoutName;
    }
}
